// add support for symbol.iterator for [first, seconds] = array;
//import 'core-js/fn/symbol/iterator.js'
//import 'core-js/es6/symbol.js'

// Foreach support for nodelist
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

// Includes fallback for IE
if (!String.prototype.includes) {
  String.prototype.includes = function (str) {
    var returnValue = false;

    if (this.indexOf(str) !== -1)
    {
      returnValue = true;
    }

    return returnValue;
  }
}
// SVG classList for IE
if (!("classList" in SVGElement.prototype)) {
  Object.defineProperty(SVGElement.prototype, "classList", {
    get() {
      return {
        contains: className => {
          return this.className.baseVal.split(" ").indexOf(className) !== -1;
        },
        add: className => {
          return this.setAttribute('class', this.getAttribute('class') + ' ' + className);
        },
        remove: className => {
          var removedClass = this.getAttribute('class').replace(new RegExp('(\\s|^)' + className + '(\\s|$)', 'g'), '$2');
          if (this.classList.contains(className)) {
            this.setAttribute('class', removedClass);
          }
        }
      };
    }
  });
}

// Classlist fallback for IE
if (!Element.prototype.hasOwnProperty('classList'))
{
  Object.defineProperty(Element.prototype, 'classList', {
    get:        function () {
      var self = this, bValue = self.className.split(' ')

      bValue.add    = function () {
        var b;
        for (i in arguments)
        {
          b = true;
          for (var j = 0; j < bValue.length; j++)
            if (bValue[j] == arguments[i])
            {
              b = false
              break
            }
          if (b)
            self.className += (self.className ? ' ' : '') + arguments[i]
        }
      }
      bValue.remove = function () {
        self.className = ''
        for (i in arguments)
          for (var j = 0; j < bValue.length; j++)
            if (bValue[j] != arguments[i])
              self.className += (self.className ? ' ' : '') + bValue[j]
      }
      bValue.toggle = function (x) {
        var b;
        if (x)
        {
          self.className = ''
          b              = false;
          for (var j = 0; j < bValue.length; j++)
            if (bValue[j] != x)
            {
              self.className += (self.className ? ' ' : '') + bValue[j]
              b = false
            }
            else b = true
          if (!b)
            self.className += (self.className ? ' ' : '') + x
        }
        else throw new TypeError('Failed to execute "toggle": 1 argument required')
        return !b;
      }

      return bValue;
    },
    enumerable: false
  })
}
